import { SOURCE_FOR_MIXPANEL_EVENTS } from 'constants/enums';
import { MIXPANEL_EVENT_NAMES } from 'constants/mixpanelEventNames';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { OpenPosition } from 'types/IOpenPosition';
import { OpenStopOrders } from 'types/IOpenStopOrders';

export const trackClosePositionSuccess = (position: OpenPosition) => {
  trackMixpanelEvent('Position Closed - Trade - Table', {
    type: 'market_order',
    quantity: position?.size,
    share_of_total_positions: 1,
    type_of_position: (position?.size ?? 0) > 0 ? 'long' : 'short',
    product_type: position?.product?.contract_type,
    source: SOURCE_FOR_MIXPANEL_EVENTS.BROKER_CHART,
  });
};

export const trackPlaceBracketOrderInteraction = (
  entity: OpenPosition | OpenStopOrders,
  type: 'CREATE' | 'UPDATE' | 'CANCEL',
  bracketSide: 'take_profit' | 'stop_loss'
) => {
  let positionOrOrder;
  switch (type) {
    case 'CREATE':
    case 'CANCEL': {
      positionOrOrder = entity as OpenPosition;
      const eventName =
        type === 'CREATE'
          ? MIXPANEL_EVENT_NAMES.BRACKET_ORDER.CHARTS_BRACKET_SET
          : MIXPANEL_EVENT_NAMES.BRACKET_ORDER.CHARTS_BRACKET_REMOVED;
      trackMixpanelEvent(eventName, {
        type: 'market_order',
        bracket_side: bracketSide,
        quantity: positionOrOrder?.size,
        product_type: positionOrOrder?.product?.contract_type,
        product_name: positionOrOrder?.product_symbol,
        source: SOURCE_FOR_MIXPANEL_EVENTS.BROKER_CHART,
      });
      break;
    }
    case 'UPDATE': {
      positionOrOrder = entity as OpenStopOrders;
      trackMixpanelEvent(MIXPANEL_EVENT_NAMES.BRACKET_ORDER.CHARTS_BRACKET_UPDATED, {
        type: 'market_order',
        bracket_side: bracketSide,
        quantity: positionOrOrder?.size,
        product_type: positionOrOrder?.product?.contract_type,
        product_name: positionOrOrder?.product_symbol,
        source: SOURCE_FOR_MIXPANEL_EVENTS.BROKER_CHART,
      });
      break;
    }
    default:
      break;
  }
};
